const { trace } = require('@opentelemetry/api');

const { getTraceparentMetaContext } = require('../resources');

class Events {
  constructor({ loggerProvider }) {
    this.context = getTraceparentMetaContext(true);
    this.spanContext = trace.getSpanContext(this.context);

    this.logger = loggerProvider.getLogger(
      '__webMonitoringName__',
      '__webMonitoringVersion__',
    );
  }

  emit(event) {
    const attrs = event.attributes || {};

    attrs['event.name'] = event.name;

    if (event.domain) {
      attrs['event.domain'] = event.domain;
    }

    if (event.data) {
      attrs['event.data'] = event.data;

      Object.entries(event.data).forEach(([key, value]) => {
        attrs[`event.data.${key}`] = value;
      });
    }

    const eventRecord = {
      timestamp: event.timestamp || Date.now(),
      name: event.name,
      attributes: attrs,
    };

    if (this.spanContext) {
      attrs.traceFlags = this.spanContext.traceFlags;
      attrs.traceId = this.spanContext.traceId;
      attrs.spanId = this.spanContext.spanId;

      eventRecord.traceFlags = this.spanContext.traceFlags;
      eventRecord.traceId = this.spanContext.traceId;
      eventRecord.spanId = this.spanContext.spanId;
    }

    this.logger.emit(eventRecord);
  }

  log(record) {
    const attrs = record.attributes || {};

    const logRecord = {
      timestamp: record.timestamp || Date.now(),
      observedTimestamp: record.observedTimestamp || Date.now(),
      severityNumber: record.severityNumber || 9, // INFO = 9, see https://github.com/open-telemetry/opentelemetry-js/blob/57008533aba7ccd51ea80f38ff4f29404d47eb9c/experimental/packages/api-logs/src/types/LogRecord.ts#L24
      severityText: record.severityText || '',
      body: record.body || '',
      attributes: attrs,
    };

    if (this.spanContext) {
      logRecord.traceFlags = this.spanContext.traceFlags;
      logRecord.traceId = this.spanContext.traceId;
      logRecord.spanId = this.spanContext.spanId;
    }

    this.logger.emit(logRecord);
  }
}

module.exports = Events;
